export default __webpack_public_path__ + "static/media/SH.b89f53b0.svg";